import axios from "axios";

import { OnboardingAnswers, OnboardingStepId } from "../lib/onboarding";

export interface OnboardingProgress {
  "workspace-id": number;
  "current-step": OnboardingStepId;
  answers: OnboardingAnswers;
  "completed-at": string | null;
  "created-at": string;
  "updated-at": string;
}

export const saveOnboardingProgress = async (
  workspaceSlug: string,
  step: OnboardingStepId,
  answers: OnboardingAnswers,
): Promise<OnboardingProgress> => {
  return (
    await axios.post(
      `/api/v1/workspaces/${workspaceSlug}/onboarding-progress`,
      { step, answers },
    )
  ).data;
};

export interface SlackInviteResult {
  url: string | null;
}

// Provision (or fetch the cached) Slack Connect invite URL for the
// current user's email domain. `url` is null when Slack isn't configured
// or provisioning failed server-side, in which case the join button is
// hidden — Slack is an optional onboarding step.
export const requestSlackInvite = async (
  workspaceSlug: string,
  signal?: AbortSignal,
): Promise<SlackInviteResult> => {
  return (
    await axios.post(
      `/api/v1/workspaces/${workspaceSlug}/slack-invites`,
      undefined,
      { signal },
    )
  ).data;
};

export interface OnboardingCompleteResult {
  redirect_url: string;
}

export const completeOnboarding = async (
  workspaceSlug: string,
): Promise<OnboardingCompleteResult> => {
  return (
    await axios.post(`/api/v1/workspaces/${workspaceSlug}/onboarding-complete`)
  ).data;
};
